<template>
  <div>
    <div class="banner" :class="'banner'+type">
      <div>
        <div v-show="type==1">
          <img src="@/assets/images/program/icon-banner1.png">
          <p class="c-fff">{{$t("program.banner[0].t1")}}</p>
          <ul>
            <li v-for='item in $t("program.banner[0].t2")' v-html="item"></li>
          </ul>
        </div>
        <div v-show="type==2">
          <img src="@/assets/images/program/icon-banner2.png">
          <p class="c-fff">{{$t("program.banner[1].t1")}}</p>
          <ul>
            <li v-for='item in $t("program.banner[1].t2")' v-html="item"></li>
          </ul>
        </div>
        <div v-show="type==3">
          <img src="@/assets/images/program/icon-banner3.png">
          <p class="c-fff">{{$t("program.banner[2].t1")}}</p>
          <ul >
            <li v-for='item in $t("program.banner[2].t2")' v-html="item"></li>
          </ul>
        </div>
        <div v-show="type==4">
          <img src="@/assets/images/program/icon-banner4.png">
          <p class="c-fff">{{$t("program.banner[3].t1")}}</p>
          <ul  >
            <li v-for='item in $t("program.banner[3].t2")' v-html="item"></li>
          </ul>
        </div>

      </div>
    </div>
    <div class="section-wrap ">

        <div class="c-999 program-label">
          <span @click="routerSkip('/')">{{$t('header.nav1')}}</span>  >  <span @click="routerSkip('/program')">{{$t('home.s4_1')}}</span>  >  <span class="c-666">{{$t('program.label['+type+']') }}</span>
        </div>
        <div class="tab-content ">
          <ul class="clearfix tech-ul">
            <li class="tech-li" v-for="(item,index) in list[type]" @click="routerSkip('/program/detail/'+type+'/'+(item.id))">
              <div>
                <div class="tech-li-img" :style="'background:url('+item.productSketchPicture +'?imageView2/2/w/400/interlace/1) no-repeat center/contain'">
                </div>
                <div class="tech-li-info">
                  <p class="c-333 cbg-textOver">{{item.productName}}</p>
                  <!--<p class="c-999 cbg-textOver mobile">{{item.label}}</p>-->
                </div>
              </div>

            </li>
          </ul>

          <div v-show="list[type] && list[type].length==0" class="tc list-text">
            {{$t("common.date_list")}}
          </div>
          <div class="pagination clearfix" v-show="list[type] &&  list[type].length>0">
            <a-pagination :class="$i18n.locale" v-model="listQuery.page" :page-size="listQuery.number" :total="listQuery.total" show-less-items @change="sizeChange"/>
          </div>
        </div>

    </div>

<div class="layerBig" v-show="showLayerBig">
<div class="bg" @click="showLayerBig=false"></div>
    <div class="abso curImg">
        <img :src="curImg" class="curImg-big " >
        <img src="@/assets/images/public/icon-close.png" class="icon-close abso" @click="showLayerBig=false">
    </div>

</div>
  </div>
</template>

<script>
  import { selectProduct } from '@api/index'


  export default {
    name: 'prize',
    data () {
      return {
         type:3,
          label:{1:"酒店/餐饮行业解决方案",2:'船舶/工厂车间解决方案',3:'食品与保健行业解决方案',4:'医院/康复中心解决方案'},
          listQuery:{
              number:12,
              page:1,
              totalPage:1,
              total:18
          },
          curImg:'',
          showLayerBig:false,
          list:{
             1:[],
              2:[],
              3:[],
              4:[]
          },


      }
    },
    
    watch: {
      $route(val) {
        console.log(val);
        if (val.params && val.params.type) {
          this.listQuery.page = 1
            this.type=val.params.type
            if(this.$i18n.locale=='cn'){
                this.listQuery.productSort=this.type
                
            }else{
                this.listQuery.productSort=this.type*1 +4
            }
          this.getList()
        }
      },
    },
    created () {
      console.log(this.$route.params.type);
        if(this.$route.params&&this.$route.params.type){
            this.type=this.$route.params.type
            if(this.$i18n.locale=='cn'){
                this.listQuery.productSort=this.type
                
            }else{
                this.listQuery.productSort=this.type*1 +4
            }

        }
    },
      mounted(){
          this.listQuery.languageType = this.$i18n.locale
          this.getList()
      },
    methods: {
        getList() {
            this.$loading.show()
            selectProduct(this.listQuery).then(res=>{
                this.$loading.hide()
                if(res.code==0){
                    this.listQuery.total=res.data.total
                    this.listQuery.totalPage=res.data.totalPage
                    this.list[this.type]=res.data.list
                }
            })
        },
        sizeChange(page,size){
            // console.log(page)
            this.listQuery.page=page
            this.getList()
        }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"

  .realize-more
    user-select none;cursor pointer
  h2,h3,h4,h5,h6,p{
    margin: 0
  }
  .list-text{font-size:.16rem}

  .banner{height:400px;background :url("~@/assets/images/program/list-banner.png") no-repeat center/auto 100%;
    img{width:.6rem;height:auto;display :block;margin:0 auto .15rem;}
    p{font-size:.3rem;    padding-bottom: .13rem;}
      ul{width:8.34rem;margin:0 auto;}
      li{color:#666;font-size:.14rem;line-height:.28rem;text-align :left;    list-style: disc;margin-bottom: .13rem;color:#fff;
      span:first-child{border-radius: 50%;width:.04rem;height:.04rem;display: inline-block;background: #666;vertical-align: middle;margin-right :.08rem;}
    }
    &.banner1{background-image :url("~@/assets/images/program/banner1.jpg")}
    &.banner2{background-image :url("~@/assets/images/program/banner2.jpg")}
    &.banner3{background-image :url("~@/assets/images/program/banner3.jpg")}
    &.banner4{background-image :url("~@/assets/images/program/banner4.jpg")}
  }


  .tab-content{margin-bottom:1.65rem;}

    .tech-ul{font-size: 0;margin-bottom :.1rem;}
    .tech-li{height:3.5rem;
      &>div{padding:0;}
    .tech-li-img{height:2.78rem;border:0;}
      .tech-li-info{height:.7rem;padding:.27rem 0.2rem;line-height 1.1;display:block;
  .c-333{font-size:.14rem;padding:0;}
      }
    }

    .tab1{background:#fff;}
  @media screen and (max-width: 768px){
    .English {
      .banner ul{width:6.8rem;padding-right:.2rem}      
      .banner li{line-height:1.5;font-size:.2rem;text-align:justify}
    }
    .list-text{font-size:.24rem}
    .section-wrap{padding:0;}
    .banner{height:5.08rem;background url("~@/assets/images/program/m-list-banner1.jpg") no-repeat center/cover;font-size:.4rem;
      ul{width:6.25rem; text-align: left;}
      li{font-size:.24rem;line-height :.4rem;margin-bottom:0;margin-left:.24rem}
      &>div{padding-bottom:.3rem}
      
    &.banner1{background-image :url("~@/assets/images/program/m-list-banner1.jpg")}
    &.banner2{background-image :url("~@/assets/images/program/m-list-banner2.jpg")}
    &.banner3{background-image :url("~@/assets/images/program/m-list-banner3.jpg")}
    &.banner4{background-image :url("~@/assets/images/program/m-list-banner4.jpg")}
    }
    .tab-content{background:#f8f8f8;margin-bottom: .95rem;}

    .tech-ul{width:93.33%;margin:0 auto;   }
    .tech-li {
      &>div{padding:0 .24rem;}
      height: 4.4rem;
      .tech-li-img {
        height: 3.4rem;border-bottom :1px solid #e5e5e5;
      }
      .tech-li-info {
        height: 1rem;padding: .22rem 0;
        .c-333 {
          font-size: .26rem;padding-bottom:.15rem;
        }
        .c-999{font-size:.24rem;}
      }
    }
    .pagination{margin-top:.6rem;}
  }
</style>
<style >
  body{background :#f8f8f8}
  </style>
